module.exports = __webpack_public_path__ + "static/media/Ubuntu Bold-01.9707e04e.svg";